"use client"
import styled from "@emotion/styled"
import { useLocale } from "next-intl"
import { LocationIcon } from "ui"
import { Apartment } from "utils"
import MiniMap from "../../../ApartmentsForRent/MiniMap"

const Container = styled.div`
  width: 100%;
`

const StyledLocationText = styled.div`
  margin: 0;
  font-family: var(--narkis) !important;
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: -0.36px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #011727;
`

const MapContainer = styled.div`
  height: 100%;
`
type Props = {
  apartment: Apartment
}

const ProjectLocation = ({ apartment }: Props) => {
  const locale = useLocale()
  const address = apartment.address ?? apartment.city

  return (
    <Container>
      <MapContainer>
        <StyledLocationText>
          <LocationIcon fill="#011727" />
          <span>{address}</span>
        </StyledLocationText>
        <MiniMap locale={locale} addressStr={address} newStyle />
      </MapContainer>
    </Container>
  )
}
export default ProjectLocation
